export enum TaxResultItemType {
  All = 0,
  CapitalGains = 1,
  Dividends = 2,
  Interest = 3,
}
